import { useMemo } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  x: string;
  y: number;
}

export const useTopStaffByOvertime = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.top_overtime_employees as DataType[];

  const chartData = useMemo<Partial<ChartProps>>(() => {
    if (data?.length) {
      const series = [
        {
          name: t('Время переработки'),
          data: data,
        },
      ];

      return {
        series,
        options: {
          chart: {
            type: 'bar',
            toolbar: { show: false },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4,
              barHeight: '60%',
            },
          },
          grid: {
            show: false,
          },
          xaxis: {
            categories: data.map((item) => item.x),
            labels: { show: false },
            axisBorder: { show: false },
            axisTicks: { show: false },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '14px',
              },
            },
          },
          dataLabels: {
            enabled: true,
            align: 'end',
            offsetX: 10,
            formatter: (_, opts) => {
              const delay = data[opts.dataPointIndex].y;
              const hours = Math.floor(delay / 60);
              const minutes = delay % 60;
              const hourPart = hours > 0 ? `${t('ч', { number: hours })} ` : '';
              const minutePart = minutes > 0 ? `${t('м', { number: minutes })}` : '';
              return `${hourPart}${minutePart}`.trim();
            },
            style: {
              colors: ['#1f2937'],
              fontSize: '14px',
            },
          },
          tooltip: {
            enabled: false,
          },
          legend: { show: false },
          colors: ['#19C37C'],
          annotations: {
            texts: [
              {
                text: t('Имена сотрудников'),
                fontSize: 12,
                x: 0,
                y: 20,
                textAnchor: 'start',
                borderColor: 'transparent',
                foreColor: '#828282',
                fontWeight: 400,
              },
            ],
          },
        },
      };
    }

    return { series: [], options: {} };
  }, [data, t]);

  return {
    label: 'Топ сотрудников по переработкам',
    type: 'bar',
    wrapped: true,
    series: chartData.series,
    options: chartData.options,
  };
};
